/**
 * Paper-criteria kinds, as `AdministratorPaperCriteria.type` reports them.
 *
 * `INTERMEDIATE` criteria are freely added and removed; `FINAL_EVALUATION` is always part of a
 * paper and cannot be removed; `REMEDIATION_EXAM` is derived — legacy mirrors the final
 * evaluation's min/max onto it and never lets it be edited on its own.
 */
export const CRITERIA_TYPE = {
  INTERMEDIATE: 0,
  FINAL_EVALUATION: 1,
  REMEDIATION_EXAM: 2,
} as const

/** Legacy caps the final evaluation's minimum at 60% of its maximum. */
export const FINAL_EVALUATION_MIN_RATIO = 0.6

/** `PUT .../criterias` rejects an `intermediateScoreLimit` outside this range. */
export const INTERMEDIATE_SCORE_LIMIT_MIN = 0
export const INTERMEDIATE_SCORE_LIMIT_MAX = 100

/**
 * A failing student whose total is strictly above this may still sit the remediation exam; legacy
 * greens their remediation cell. Exactly 41 renders red on legacy, so the comparison is `>`.
 */
export const REMEDIATION_ELIGIBLE_ABOVE = 41
